export default {
    apiURL: process.env.REACT_APP_API_URL,
    clientId: process.env.REACT_APP_CLIENT_ID || undefined,
    clientSecret: process.env.REACT_APP_CLIENT_SECRET || undefined,
    enviroment: process.env.REACT_APP_ENV || undefined,
    sentry_dsn: process.env.REACT_APP_SENTRY_DSN || undefined,
    agencias2URL: process.env.REACT_APP_AGENCIAS2_URL || 'https://agencias2.decreditos.com',
    agencias2Login: process.env.REACT_APP_AGENCIAS2_LOGIN || 'https://agencias2.decreditos.com/login',
}
